import { ColumnDef } from "@tanstack/react-table";
import clsx from "clsx";
import DynamicTable from "features/DynamicTable";
import DynamicTableFooter from "features/DynamicTable/components/DynamicTableFooter";
import useTableColumns from "features/Inventory/useTableColumns";
import React from "react";
import {
  dynamicTableStore,
  TableMode,
} from "features/DynamicTable/DynamicTableStore";
import LoadingIcon from "components/LoadingIcon";
import { observer } from "mobx-react-lite";
import { buildingStore } from "store/Building/BuildingStore";
import EmptyState from "components/EmptyState";
import { useTranslation } from "react-i18next";

const Inventory = () => {
  const { t } = useTranslation();
  const [initialLoading, setInitialLoading] = React.useState(true);
  const getColumns = () => {
    return useTableColumns() as ColumnDef<unknown, unknown>[];
  };

  const getData = async (start: number, _: number, update?: boolean) => {
    await dynamicTableStore.fetchObjectsList(start, update);
  };

  const showLoading =
    !dynamicTableStore.data.items.length &&
    (dynamicTableStore.dataFetchLoading ||
      !dynamicTableStore.visibleColumnProperties.length);

  function loadingView() {
    return (
      <div className="absolute flex flex-col items-center justify-center bg-gray-50 !flex-grow z-4 w-full min-h-full">
        <LoadingIcon className="min-h-20 min-w-20 my-4" />
        <div className="mb-4 text-gray-500">
          {t("emptyState.loadingTitleInventory")}
        </div>
      </div>
    );
  }

  React.useEffect(() => {
    setInitialLoading(showLoading);
  }, [showLoading]);

  if (!buildingStore.currentBuilding?.active_ifc_files?.length)
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.calculationsStatus.inProgress}
        noBorder
        containerClassName="flex-grow"
      />
    );

  return (
    <div className="relative flex flex-grow flex-col">
      {initialLoading && loadingView()}

      <div
        className={clsx(
          "flex flex-col items-center w-full max-h-[calc(100vh-155px)] relative flex-grow"
        )}
      >
        <DynamicTable
          mode={TableMode.Inventory}
          getColumns={getColumns}
          title="Inventar"
          getData={getData}
          columnStyles="!border-r-gray-200"
        />
      </div>

      <DynamicTableFooter />
    </div>
  );
};

export default observer(Inventory);
